import React from 'react';
import { PrimaryButton, SecondaryButton } from '../../../ui/common';
import { MapPinIcon } from '../icons';
import { FormInput } from '../calendar.styles';

function AddressModal({ isOpen, onClose, values = {}, onSave }) {
  const [local, setLocal] = React.useState({
    street: values.street || '',
    building_number: values.building_number || '',
    apartment_number: values.apartment_number || '',
    postal_code: values.postal_code || '',
    city: values.city || ''
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setLocal({
      street: values.street || '',
      building_number: values.building_number || '',
      apartment_number: values.apartment_number || '',
      postal_code: values.postal_code || '',
      city: values.city || ''
    });
  }, [isOpen, values]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave({
      street: local.street || '',
      building_number: local.building_number || '',
      apartment_number: local.apartment_number || '',
      postal_code: local.postal_code || '',
      city: local.city || ''
    });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 6000
    }} onClick={onClose}>
      <div style={{
        background: 'var(--card-bg)', borderRadius: '14px', padding: '20px',
        width: 'min(720px, 96vw)', border: '1px solid var(--input-border)'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <h3 style={{ margin: 0, display: 'flex', gap: '8px', alignItems: 'center' }}><MapPinIcon /> Edytuj adres</h3>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: '20px', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ display: 'grid', gap: '10px' }}>
          <div>
            <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Ulica</label>
            <FormInput value={local.street} onChange={e => setLocal(l => ({ ...l, street: e.target.value }))} placeholder="Ulica" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Nr budynku</label>
              <FormInput value={local.building_number} onChange={e => setLocal(l => ({ ...l, building_number: e.target.value }))} placeholder="Nr budynku" />
            </div>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Nr lokalu</label>
              <FormInput value={local.apartment_number} onChange={e => setLocal(l => ({ ...l, apartment_number: e.target.value }))} placeholder="Nr lokalu (opcjonalnie)" />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Kod pocztowy</label>
              <FormInput value={local.postal_code} onChange={e => setLocal(l => ({ ...l, postal_code: e.target.value }))} placeholder="00-000" />
            </div>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Miasto</label>
              <FormInput value={local.city} onChange={e => setLocal(l => ({ ...l, city: e.target.value }))} placeholder="Miasto" />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '6px' }}>
            <SecondaryButton onClick={onClose}>Anuluj</SecondaryButton>
            <PrimaryButton onClick={handleSave}>Zapisz adres</PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddressModal;
